import { Box, Icon } from "@chakra-ui/react";
import { IconType } from "react-icons";

interface IconSquareProps {
  icon: IconType;
  /** Chakra color token for the square background, e.g. "red.50". */
  bg?: string;
  /** Chakra color token for the icon, e.g. "red.500". */
  color?: string;
  size?: number | string;
}

/** A small colored rounded square holding an icon — generic version of the meeting type badge. */
export default function IconSquare({ icon, bg = "gray.100", color = "gray.600", size = "36px" }: IconSquareProps) {
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      w={size}
      h={size}
      bg={bg}
      borderRadius="md"
      flexShrink={0}
    >
      <Icon as={icon} boxSize={4} color={color} />
    </Box>
  );
}
